<div class="ir-login-image-wrapper">
  <img class="ir-login-image" src="../../assets/img/logo.svg" alt="Logo" width="150" />
</div>
<div class="container">
  <div class="row justify-content-center">
    <div class="card password-recovery-wrapper">
      <div class="card-header">
        <h3>Reset password</h3>
      </div>
      <div class="card-body">
        <form [formGroup]="userForm" class="d-flex flex-column justify-content-between">
          <div class="form-group">
            <label for="user">User</label>

            <input
              class="form-control"
              id="user"
              placeholder="User*"
              formControlName="user"
              name="user"
              type="text"
              [ngClass]="{ 'input-error': user?.touched && user?.invalid }"
              (keyup)="enableReset()" />
            <small class="text-muted fs-6"
              >Enter your Username. You will receive an Email with instructions, how to recover your password.</small
            >
          </div>
          <div class="form-actions">
            <button class="form-control form-control-lg" [disabled]="!enableReset()" type="button" (click)="resetPassword()">
              Send reset link
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
